import { LOC_OUTGOING_MESSAGE_WF, LOC_SENDING_OF_WF_MESSAGE } from "../../locKeys";
import { parseStringToBoolean } from "../../utils";
import { Action } from "./Action";

export class SendWFMessage extends Action {
    public messageName: string;
    public targetObjectName: string;
    public objectsCondition: string;
    public objectsConditionParams: string;
    public afterSave: boolean;

    constructor(messageName: string, targetObjectName: string, objectsCondition: string, objectsConditionParams: string, afterSave: string, condition: string, comment: string) {
        super(condition, comment);

        this.messageName = messageName;
        this.targetObjectName = targetObjectName;
        this.objectsCondition = objectsCondition;
        this.objectsConditionParams = objectsConditionParams;
        this.afterSave = parseStringToBoolean(afterSave, false);
    }

    public override async validate(): Promise<void> {
        if (!this.messageName)
            throw new Error(await this.getActionErrorMessage(LOC_OUTGOING_MESSAGE_WF, LOC_SENDING_OF_WF_MESSAGE));
    }
}
